import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["element", "slot"],
  _excluded2 = ["children"];
import React, { forwardRef } from 'react';
import { ClearSlots, useSlotProps } from '../../utils/slots';
var Slot = forwardRef(function Slot(props, ref) {
  var Element = props.element,
    slot = props.slot,
    rest = _objectWithoutProperties(props, _excluded);
  var _useSlotProps = useSlotProps(rest, slot),
    children = _useSlotProps.children,
    otherProps = _objectWithoutProperties(_useSlotProps, _excluded2);
  return React.createElement(Element, _extends({}, otherProps, {
    ref: ref
  }), React.createElement(ClearSlots, null, children));
});
export default Slot;